import React, { useContext, useEffect } from "react";
import { Helmet } from "react-helmet";
import {
  useNavigate,
  useSearchParams,
  Link as RouterLink,
} from "react-router-dom";
import { Box, Breadcrumbs, Link, Typography } from "@mui/material";

import { AuthContext } from "../../context/AuthContextProvider";
import AddMember from "../../components/AddMember";
import { toast } from "sonner";
import { addMember } from "../../api/settings";
import { ANALYTICS_EVENTS, logAnalyticsEvent } from "../../analytics";
import useCreditWallet from "../../hooks/useCreditWallet";

const AddPeople = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const type = searchParams.get("type");
  const { loading: walletLoading, isUserLimitReached } = useCreditWallet();

  // Block the /add-member page entirely once the Custom Plan's member limit
  // is reached, instead of letting the user fill out the whole form and only
  // find out at submit time (the backend's checkSubscriptionLimit('user')
  // middleware would reject it with a 403 anyway).
  useEffect(() => {
    if (!walletLoading && isUserLimitReached) {
      toast.error("You've reached your plan's member limit. Upgrade your plan to add more members.");
      navigate("/settings/members", { replace: true });
    }
  }, [walletLoading, isUserLimitReached, navigate]);

  const handleAddMember = async (data) => {
    try {
      const response = await addMember(data);
      if (response.success) {
        // Only the role and centre are read off the payload — it also carries the
        // new member's name, phone, email and default password, none of which
        // may go to GA4. centerIds can hold several centres; the first is the
        // primary assignment.
        logAnalyticsEvent(ANALYTICS_EVENTS.MEMBER_ADDED, {
          added_user_id: response?.data?.[0]?._id || response?.data?._id,
          assigned_role: data?.role,
          assigned_centre_id: data?.centerIds?.[0],
        });
        toast.success("Member added successfully");
        navigate("/settings/members");
      } else {
        toast.error(response.message);
      }
    } catch (e) {}
  };

  return (
    <>
      <Helmet>
        <title>Spandan - Add People</title>
      </Helmet>

      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content">
            <div className="page-header">
              <Box sx={{ mb: 2 }}>
                <Breadcrumbs separator="/" sx={{ mb: 1 }}>
                  <Link
                    component={RouterLink}
                    to="/settings"
                    underline="hover"
                    sx={{
                      fontSize: "14px",
                      fontFamily: "Figtree",
                      color: "var(--app-text)",
                      fontWeight: 400,
                      fontStyle: "regular",
                    }}
                  >
                    Settings
                  </Link>

                  <Link
                    component={RouterLink}
                    to="/settings/members"
                    underline="hover"
                    sx={{
                      fontSize: "14px",
                      fontFamily: "Figtree",
                      color: "var(--app-text)",
                      fontWeight: 400,
                      fontStyle: "regular",
                    }}
                  >
                    Manage Members
                  </Link>

                  <Typography
                    color="var(--app-text)"
                    sx={{
                      fontSize: "14px",
                      fontFamily: "Figtree",
                      fontWeight: 600,
                    }}
                  >
                    Add New Member
                  </Typography>
                </Breadcrumbs>

                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 700,
                    fontFamily: "Figtree",
                    color: "var(--app-text)",
                    fontSize: "20px",
                    fontStyle: "Bold",
                  }}
                >
                  Add New Member
                </Typography>
              </Box>
            </div>

            <div className="col-md-12 ">
              {/* Profile Card */}
              <div>
                <AddMember
                  handleAddMember={handleAddMember}
                  type="add"
                  preselectedCenterId={id}
                  preselectedCenterType={type}
                />
              </div>
            </div>

            {/* <Topnav array="setup" /> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default AddPeople;
